import { h, Component } from 'preact'
import { connect } from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import Renderer from "../canvas/renderer";
import { updatePageBars } from '../canvas/selection';
import util, { roundTo25 } from "../util";
import Interactable from "../canvas/interactable";
import { DownOutlined, FullscreenOutlined } from '@ant-design/icons';

export default @connect(reduce, actions)
class ResizeTextWidget extends Component {
  constructor(props) {
    super();
    this.state = {};

    this.initElement(props);
  }

  initElement(props) {
    this.$element = props.$element;

    if (this.$element) {
      this.throttledForceUpdate = util.throttle(() => {
        const isInch = !props.unit || props.unit === 'in';
        this.state.width = isInch ? this.$element.attr('data-inch-width') : this.$element.attr('data-px-width');
        this.forceUpdate()
      }, 50);

      if (this.observer) {
        this.observer.disconnect();
      }

      this.observer = new window.MutationObserver(mutations => mutations.forEach(this.throttledForceUpdate.bind(this)))
      this.observer.observe(this.$element[0], {
        attributes: true,
        attributeFilter: ['style'],
      });
    }
  }

  onWidthChange(ev) {
    const props = this.props;
    const isInch = !props.unit || props.unit === 'in';
    let width = ev.target.value;
    if (width && parseFloat(width) !== 0) {
      if (width < .15) width = .15;

      const scale = Interactable.of(props.$element).getScale();
      width /= scale;

      const cfg = {
        'in': isInch ? width : null,
        'px': !isInch ? width : null,
      };

      Renderer.updateElementWidth(this.props.isMultiSelect ? this.props.$elements : this.props.$element, cfg);

      props.updateElementAttribute('width', width);
      props.$element.attr('data-px-width', width);
      updatePageBars(props.$element);
    }
  };

  componentWillReceiveProps(nextProps, nextContext) {
    this.initElement(nextProps);
  }

  render(props, state) {
    let width = state.width || props.width;
    const scale = Interactable.of(props.$element).getScale();

    width = roundTo25(width * scale);

    return (
      <div className="dropdown sizes">
        {!props.isMobileVersion && <a className="dropdown-toggle icn rwd-icon" data-hint="Size">Size</a>}
        {props.isMobileVersion && <a className="dropdown-toggle mobile-tool-widget">
          <FullscreenOutlined />
          <span>Size</span>
        </a>}

        <div className="dropdown-menu" style="width: auto; min-width: 260px;" data-close="no">
          {props.isMobileVersion && <div className="mobile-dropdown-header">
            <span>Size</span>
            <div className="dropdown-toggle"><DownOutlined /></div>
          </div>}
          <ul>
            <li className="shape-resize">
              <div>
                <label>Width</label>
                <div>
                  <input type="number" step=".25" value={width} onChange={util.debounce(this.onWidthChange.bind(this))} />
                  <span className="unit">{props.unit}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}
